
import {apiHelper} from '@/util'

/* SERVICE EXPORT FUNCTION NAME */
export const vipTierService = {
  getRecurringBonus,
  postRecurringBonus
}

/* SERVICE URL PATH */
const VIPTIER = {
  VIP_TIER: 'vipTier',
  RECURRING_BONUS: 'recurring_bonus'
}

function getRecurringBonus() {
  return apiHelper().get(`${VIPTIER.VIP_TIER}/${VIPTIER.RECURRING_BONUS}`)
}

function postRecurringBonus(data) {
  const requestBody = {
    type: data.type
  }
  return apiHelper().post(`${VIPTIER.VIP_TIER}/${VIPTIER.RECURRING_BONUS}`, requestBody)
}
